import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ShareReceiptRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ShareReceiptResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const shareReceipt = (request: ShareReceiptRequest, options?: CashRequestOptions) =>
  post<ShareReceiptRequest, ShareReceiptResponse>('/2.0/cash/share-receipt', request, {
    ...options,
    rejectOnError: true,
  })
